<template>
  <HorizontalStep
    v-if="isHorizontal"
    :active="active"
    :flow="flow"
    :index="stepIndex"
  />
  <VerticalStep
    v-else
    :active="active"
    :index="stepIndex"
  >
    <template #default>
      <slot name="default" />
    </template>
    <template #icon>
      <slot name="icon" />
    </template>
  </VerticalStep>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { stepItemEmits } from './item-emits';
import { createNamespace } from '../utils/components';
import { useStepItem } from './hooks';
import HorizontalStep from './components/step-horizontal.vue';
import VerticalStep from './components/step-vertical.vue';

const { name, n, classes } = createNamespace('step-item');

export default defineComponent({
  name,
  components: {
    HorizontalStep,
    VerticalStep,
  },
  props: {},
  emits: stepItemEmits,
  setup() {
    const { direction, active, flow, stepIndex } = useStepItem();
    // 是否横向模式
    const isHorizontal = computed(() => direction.value === 'horizontal');

    return {
      n,
      classes,
      stepIndex,
      active,
      flow,
      isHorizontal,
    };
  },
});
</script>
